import FSpanTil from './FSpanTil.vue'

export default FSpanTil
